import { supabaseClient } from 'supabase'
import { requireStamp } from './deskDecisionError'

/**
 * Dismiss the editor's match: the candidate stays a new event
 * (`desk_dismiss_match`, D-14).
 *
 * Resolves with the `desk_match_dismissed_at` it stamped, exactly as sent (the
 * Undo guard, review AD-WR-11).
 *
 * Errors are thrown raw; a null result throws DeskAlreadyDecidedError (D-11).
 */
export const dismissMatch = async (id: number): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_dismiss_match', { p_id: id })

  if (error) {
    throw error
  }
  return requireStamp('desk_dismiss_match', data)
}
